{
  "You're invited to watch {title}": "Te invitamos a ver {title}",
  "Share your event link": "Comparte el enlace de tu evento",
  "device|desktop": "computadora",
  "device|phone": "celular",
  "device|tablet": "tableta",
  "device|tv": "televisión",
  "device|console": "consola",
  "{hours}h {minutes}m": "{hours} h {minutes} min",
  "Sorry, there's been an error loading the analytics data.": "Lo sentimos, hubo un error al cargar las estadísticas.",
  "Detailed analytics are available for events starting May 20, 2025. Below are the basic statistics for this event.": "Las estadísticas detalladas están disponibles para los eventos a partir del 20 de mayo de 2025. A continuación verás las estadísticas básicas de este evento.",
  "Viewed Live": "Vieron en vivo",
  "Watched Replay": "Vieron la grabación",
  "Powered by": "Con la tecnología de",
  "{count} views": {
    "one": "{count} vista",
    "other": "{count} vistas"
  },
  "{count} viewers": {
    "one": "{count} espectador",
    "other": "{count} espectadores"
  },
  "Total Views": "Vistas totales",
  "Unique Viewers": "Espectadores únicos",
  "Total Watch Time": "Tiempo total visto",
  "Views": "Vistas",
  "Watch Time": "Tiempo visto",
  "Top Countries": "Principales países",
  "Top Regions / States": "Principales regiones / estados",
  "analytics|Unknown": "Desconocido",
  "Device Categories": "Tipos de dispositivo",
  "Operating Systems": "Sistemas operativos",
  "Import": "Importar",
  "Invite a guest": "Invitar a una persona",
  "We'll email them the event link and remind them before you go live.": "Le enviaremos por correo el enlace del evento y se lo recordaremos antes de que transmitas en vivo.",
  "CSV Import": "Importar CSV",
  "Select File": "Seleccionar archivo",
  "Format: CSV. Required column: Email. Optional columns: Name, First Name, Last Name": "Formato: CSV. Columna obligatoria: “Email”. Columnas opcionales: “Name”, “First Name”, “Last Name” (en inglés)",
  "Invite All ({count})": "Invitar a todos ({count})",
  "Couldn't load the guest list": "No se pudo cargar la lista de invitados",
  "Remove the guest from the list?": "¿Quitar a este invitado de la lista?",
  "guest status|Joined Live": "Se unió en vivo",
  "guest status|Watched Replay": "Vio la grabación",
  "guest status|Visited page": "Visitó la página",
  "guest status|Invited": "Invitación enviada",
  "{count} guest": {
    "one": "{count} invitado",
    "other": "{count} invitados"
  },
  "Open the guest list": "Abrir la lista de invitados",
  "Guests of every {noun} are on the guest list of {label} (the main link). They sign up once and can watch every {noun}.": "Los invitados de cada {noun} están en la lista de invitados de {label} (el enlace principal). Se registran una sola vez y pueden ver cualquier {noun}.",
  "Start inviting guests": "Empieza a invitar",
  "Invite guests by email or just share your event link with them.": "Envía invitaciones por correo o simplemente comparte el enlace de tu evento.",
  "Guests who sign the guestbook or ask for reminders appear here too.": "Aquí también aparecen los invitados que firman el libro de visitas o piden recordatorios.",
  "Share link": "Compartir enlace",
  "Download guest list": "Descargar lista de invitados",
  "Guests {title}.csv": "Invitados {title}.csv",
  "Guests.csv": "Invitados.csv",
  "{title}-report.pdf": "{title}-informe.pdf",
  "analytics-report.pdf": "informe-de-estadisticas.pdf",
  "Export PDF": "Exportar PDF",
  "Invitation sent": "Invitación enviada",
  "{name} will get reminders before you go live.": "{name} recibirá recordatorios antes de que transmitas en vivo.",
  "Couldn't send the invitation": "No se pudo enviar la invitación",
  "Guest's name": "Nombre del invitado",
  "e.g. Maria Lopez": "p. ej., María López",
  "Send invitation": "Enviar invitación",
  "Could not open image library.": "No se pudo abrir la galería de fotos.",
  "Delete Cover?": "¿Eliminar la foto de portada?",
  "Delete failed": "No se pudo eliminar",
  "Processing image...": "Procesando imagen...",
  "Uploading... {percent}%": "Subiendo... {percent}%",
  "Invalid file": "Archivo no válido",
  "Only JPG or PNG files are accepted": "Solo se aceptan archivos JPG o PNG",
  "Drop image here": "Suelta la imagen aquí",
  "Drop image here or click to select": "Suelta la imagen aquí o haz clic para elegirla",
  "Recommended size: 1280x720 pixels": "Tamaño recomendado: 1280x720 píxeles",
  "Accepts PNG or JPG under 50MB": "Acepta PNG o JPG de menos de 50 MB",
  "Couldn't save that": "No se pudo guardar",
  "Guests who watch on your website get emails that link back to the page they watched on.": "Los invitados que ven el evento en tu sitio web reciben correos con enlaces a la página donde lo vieron.",
  "Pages where guests watch your embed will show up here.": "Aquí aparecerán las páginas donde los invitados vean tu embed.",
  "Seen on": "Visto en",
  "Use for email links": "Usar en los correos",
  "Ignore": "Ignorar",
  "Used for email links": "Se usan en los correos",
  "Stop using": "Dejar de usar",
  "Other guests": "Otros invitados",
  "Your Embed webpage URL from before. Remove it to send everyone else to evt.live.": "La URL de la página con tu embed que configuraste antes. Quítala para enviar a todos los demás a evt.live.",
  "EventLive event": "Evento de EventLive",
  "How this event's page looks to guests. It overrides the branding in your profile.": "Cómo ven los invitados la página de este evento. Tiene prioridad sobre la marca de tu perfil.",
  "Could not update branding settings": "No se pudo actualizar la configuración de marca",
  "Event page": "Página del evento",
  "Description": "Descripción",
  "A few words for your guests": "Unas palabras para tus invitados",
  "Supports Markdown: **bold**, lists and links.": "Admite Markdown: **negrita**, listas y enlaces.",
  "e.g. 7pm ET / 4pm PT": "p. ej., 7 p. m. CDMX / 8 p. m. Bogotá",
  "Replaces the date and time on your event page and in reminder emails.": "Reemplaza la fecha y la hora en la página de tu evento y en los correos de recordatorio.",
  "Company": "Empresa",
  "Shown on this event page only. PNG or JPG; it's trimmed and resized automatically. Horizontal logos work best. A white logo on a transparent background may not show on a light page.": "Solo se muestra en la página de este evento. PNG o JPG; se recorta y se ajusta su tamaño automáticamente. Los logotipos horizontales se ven mejor. Un logotipo blanco sobre fondo transparente puede no verse en una página clara.",
  "Put your event page or just the video player on your own website.": "Pon la página de tu evento o solo el reproductor de video en tu propio sitio web.",
  "Layout": "Diseño",
  "Full embed": "Embed completo",
  "The event page: video, guestbook and reminders.": "La página del evento: video, libro de visitas y recordatorios.",
  "Just video": "Solo video",
  "Only the video player.": "Solo el reproductor de video.",
  "These change the code below. Copy it again after changing them.": "Estas opciones cambian el código de abajo. Vuelve a copiarlo después de cambiarlas.",
  "Autoplay": "Reproducción automática",
  "Start the video automatically.": "Inicia el video automáticamente.",
  "Reminder button": "Botón de recordatorios",
  "Guests can sign up for reminders from your website.": "Los invitados pueden pedir recordatorios desde tu sitio web.",
  "No replay and no rewind in the embed.": "Sin grabación y sin poder retroceder en el embed.",
  "Script (recommended)": "Script (recomendado)",
  "Viewers who open an EventLive email link on your page are recognized there, and the player is sized to fit.": "Se reconoce a los espectadores que abren en tu página un enlace de un correo de EventLive, y el reproductor ajusta su tamaño.",
  "Simple iframe (no script)": "Iframe simple (sin script)",
  "For site builders that remove scripts. The player can't see viewers' email links, so ticket holders on a new device may have to sign in again.": "Para creadores de sitios web que eliminan los scripts. El reproductor no ve los enlaces de los correos de los espectadores, así que quien tenga boleto podría tener que volver a iniciar sesión en un dispositivo nuevo.",
  "Embed code": "Código embed",
  "Copy embed code": "Copiar el código",
  "Embed code copied": "Código copiado",
  "Paste it into your website's HTML.": "Pégalo en el HTML de tu sitio web.",
  "Preview": "Vista previa",
  "Couldn't load the guestbook": "No se pudo cargar el libro de visitas",
  "Delete this message?": "¿Eliminar este mensaje?",
  "Messaging": "Mensajería",
  "Chat": "Chat",
  "You pinned": "Fijado por ti",
  "Delete this message": "Eliminar este mensaje",
  "Could not update messaging settings": "No se pudo actualizar la configuración de mensajes",
  "Guests sign it and add photos. Newest messages first.": "Los invitados lo firman y suben fotos. Los mensajes más recientes aparecen primero.",
  "A live chat next to the video, like a group conversation.": "Un chat en vivo junto al video, como una conversación en grupo.",
  "Disable messaging": "Desactivar los mensajes",
  "Guests can watch but can't post messages.": "Los invitados pueden ver el evento, pero no publicar mensajes.",
  "{count} message": {
    "one": "{count} mensaje",
    "other": "{count} mensajes"
  },
  "Loading messages…": "Cargando mensajes…",
  "No messages yet. They'll appear here as guests post them.": "Todavía no hay mensajes. Aparecerán aquí cuando los invitados los publiquen.",
  "Could not update privacy settings": "No se pudo actualizar la configuración de privacidad",
  "Hide event page": "Ocultar la página del evento",
  "Manage tickets": "Administrar boletos",
  "Guests need a ticket to watch. To let some guests in for free, invite them from the Guest List.": "Los invitados necesitan un boleto para verlo. Para dejar entrar gratis a algunos, invítalos desde la lista de invitados.",
  "Anyone with the link can watch": "Cualquiera con el enlace puede verlo",
  "Share the link; no password or invitation needed.": "Comparte el enlace; no hace falta contraseña ni invitación.",
  "Password protected": "Protegido con contraseña",
  "Guests enter a password you give them.": "Los invitados escriben la contraseña que les des.",
  "Choose a password": "Elige una contraseña",
  "Invite only": "Solo con invitación",
  "Only the guests invited by email can join. One device per email at a time. (MUST be on the <list>Guest List</list>)": "Solo pueden entrar los invitados por correo. Un dispositivo por correo a la vez. (DEBEN estar en la <list>lista de invitados</list>)",
  "Ask guests for their name and email": "Pedir a los invitados su nombre y correo",
  "Always on for invite-only events.": "Siempre activado en los eventos solo con invitación.",
  "Before they can watch. They'll appear in your Guest List.": "Antes de que puedan verlo. Aparecerán en tu lista de invitados.",
  "Replay and download": "Grabación y descarga",
  "Show download link to guests": "Mostrar el enlace de descarga a los invitados",
  "Hide viewer counter": "Ocultar el contador de espectadores",
  "Your event page is hidden. People who bought tickets can't watch until you show it again.": "La página de tu evento está oculta. Quienes compraron boletos no pueden ver el evento hasta que vuelvas a mostrarla.",
  "Your event page is hidden. Guests can't open it until you show it again.": "La página de tu evento está oculta. Los invitados no pueden abrirla hasta que vuelvas a mostrarla.",
  "Show event page": "Mostrar la página del evento",
  "Remove {guest} from the guest list": "Quitar a {guest} de la lista de invitados",
  "Message pinned": "Mensaje fijado",
  "Guests see it at the top of the guestbook.": "Los invitados lo ven en la parte superior del libro de visitas.",
  "Couldn't pin the message": "No se pudo fijar el mensaje",
  "e.g. Welcome! The ceremony starts at 3 pm.": "p. ej., ¡Bienvenidos! La ceremonia empieza a las 3 p. m.",
  "Stays at the top of the guestbook or chat.": "Se mantiene en la parte superior del libro de visitas o del chat.",
  "Pin message": "Fijar mensaje",
  "Share on {network}": "Compartir en {network}",
  "Share on Email": "Compartir por correo",
  "Preview my Event Page": "Ver la página de mi evento",
  "Share via:": "Compartir por:",
  "Viewer-hours": "Horas-espectador",
  "{count} viewer-hour": {
    "one": "{count} hora-espectador",
    "other": "{count} horas-espectador"
  },
  "Live {live} · Replay {replay}": "En vivo {live} · Grabación {replay}",
  "Ticketed events have no viewer-hour limit.": "Los eventos con boletos no tienen límite de horas-espectador.",
  "{used} of {limit} viewer-hours included with this event": "{used} de las {limit} horas-espectador incluidas con este evento",
  "Over the {limit} viewer-hours included with this event by {over}.": "Supera en {over} las {limit} horas-espectador incluidas con este evento.",
  "By day (UTC)": "Por día (UTC)",
  "Show fewer days": "Mostrar menos días",
  "Show all {count} days": {
    "one": "Mostrar {count} día",
    "other": "Mostrar los {count} días"
  },
  "Viewer-hours are updated every hour. They show here within an hour of people watching.": "Las horas-espectador se actualizan cada hora. Aparecen aquí menos de una hora después de que la gente vea el evento.",
  "Live viewers": "Espectadores en vivo",
  "Devices watching each minute of the live stream.": "Dispositivos viendo cada minuto de la transmisión en vivo.",
  "Live viewers per minute from {start} to {end}. Peak: {peak} at {time}.": "Espectadores en vivo por minuto de {start} a {end}. Máximo: {peak} ({time}).",
  "Peak: {count} at {time}": "Máximo: {count} ({time})",
  "{count} viewer at {time}": {
    "one": "{count} espectador ({time})",
    "other": "{count} espectadores ({time})"
  },
  "Browsers and apps": "Navegadores y apps",
  "{count} viewer": {
    "one": "{count} espectador",
    "other": "{count} espectadores"
  },
  "Regions:": "Regiones:",
  "IP Geolocation by DB-IP": "Geolocalización IP de DB-IP",
  "Before {date}": "Antes del {date}",
  "From our previous analytics, which counted browsers only, saved for good before they expired.": "De nuestras estadísticas anteriores, que solo contaban navegadores, guardadas para siempre antes de que se perdieran.",
  "Viewers": "Espectadores",
  "{live} live · {replay} replay only": "{live} en vivo · {replay} solo grabación",
  "{time} per viewer": "{time} por espectador",
  "Peak live viewers": "Máximo de espectadores en vivo",
  "Watch time, views, countries and devices are counted from {date}. Unique viewers are counted for every event.": "El tiempo visto, las vistas, los países y los dispositivos se cuentan desde el {date}. Los espectadores únicos se cuentan en todos los eventos.",
  "Viewers here are devices on each day: someone watching on two days counts twice. Counted every hour from the video our CDN delivered, on every player.": "Aquí, los espectadores son dispositivos por día: alguien que mira en dos días cuenta dos veces. Se cuentan cada hora a partir del video que entregó nuestra CDN, en todos los reproductores.",
  "Each viewer counts once, however many days they watch. Counted every hour from the video our CDN delivered, on every player.": "Cada espectador cuenta una vez, aunque mire varios días. Se cuentan cada hora a partir del video que entregó nuestra CDN, en todos los reproductores.",
  "analytics|Other": "Otros",
  "Analytics are updated every hour. They show here within an hour of people watching.": "Las estadísticas se actualizan cada hora. Aparecen aquí menos de una hora después de que la gente vea el evento.",
  "Counted from {date}; the viewing before it is further down.": "Contado desde el {date}; lo que se vio antes está más abajo.",
  "Counted from {date}; the viewing before it wasn't counted.": "Contado desde el {date}; lo que se vio antes no se contó.",
  "Live viewing during {times} isn't fully counted: our video network didn't save all its logs for that time.": "No se cuenta todo lo que se vio en vivo durante {times}: nuestra red de video no guardó todos sus registros de ese momento.",
  "Updated hourly.": "Se actualizan cada hora.",
  "Last updated {date}, {time}": "Última actualización: {date}, {time}",
  "analytics|Live": "En vivo",
  "analytics|Replay": "Grabación"
}
